import { render, staticRenderFns } from "./Drug.vue?vue&type=template&id=601432b6&scoped=true"
import script from "./Drug.vue?vue&type=script&lang=js"
export * from "./Drug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601432b6",
  null
  
)

export default component.exports